export default "__VITE_ASSET__BV2bMNak__"